import { Component, ChangeDetectionStrategy, inject, afterNextRender, viewChild, signal } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { DateTime } from 'luxon';
import { AuthRequestComponent } from './auth-request/auth-request.component';
import { AuthVerifyComponent } from './auth-verify/auth-verify.component';
import { AuthRegisterComponent } from './auth-register/auth-register.component';
import { AuthService } from '../../auth.service';
import { IAuthRequest, IAuthResponse, IAuthVerified } from '../../types';
import { MetaService } from '../../meta.service';

@Component({
  selector: 'cloudigo-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AuthRequestComponent, AuthVerifyComponent, AuthRegisterComponent]
})
export default class AuthComponent {

  // request = viewChild(AuthRequestComponent);
  verify = viewChild(AuthVerifyComponent);
  // register = viewChild(AuthRegisterComponent);

  meta = inject(MetaService);
  auth = inject(AuthService);

  loading = signal<boolean>(false);
  protected state = signal<'request' | 'verify' | 'register'>('request');

  pageContents = [
    {
      title: 'Welcome to cloudigo!',
      text: 'Start saving money in an instant.',
      image: 'old/auth/save-money.png',
      image_alt: 'People saving money'
    },
    {//giftClaim
      title: 'Your gift awaits!',
      text: 'The next step is to <strong>create an account</strong> on cloudigo below by signing up with your phone number.',
      image: 'old/friends/baf-generic-image.webp',
      image_alt: 'cloudigo Gift'
    },
    {//boughtCoupon:default
      title: 'Your transaction was successful!',
      text: 'Thank you for purchasing <strong>cloudigo Traveller</strong>! The next step is to <strong>create an account</strong> on cloudigo below by signing up with your phone number. Once your account is created, you will be able to <strong>book and purchase excursion</strong> at a discount for your upcoming trip.',
      image: 'old/tourist/success-default.png',
      image_alt: 'cloudigo Tourist App'
    },
    {//boughtCoupon:arrigo
      title: 'Your transaction was successful!',
      text: 'Thank you for purchasing <strong>cloudigo Traveller</strong>! The next step is to <strong>create an account</strong> on cloudigo below by signing up with your phone number.',
      image: 'old/tourist/success-arrigo.png',
      image_alt: 'Tourists enjoying cloudigo'
    },
    {//redirect:corporateCode
      title: 'Your free benefit awaits!',
      text: 'The next step is to <strong>login</strong> or <strong>create an account</strong> on cloudigo below to claim it.',
      image: 'old/friends/baf-generic-image.webp',
      image_alt: 'cloudigo Benefit'
    }
  ];

  pageContentSelected = signal<number>(0);

  constructor() { 
    this.meta.setTags('cloudigo Malta - Login or Register', 'Login or Register to start benefitting from discounts on cloudigo. Enter your mobile number to get started!');

    afterNextRender(() => {
      this.auth.getIP();

      try {
        const boughtCoupon = localStorage?.getItem('coupon-session');
        const plan = localStorage?.getItem('coupon-session-plan');
        const giftClaim = localStorage?.getItem('gift-session-claim');
        const redirectInfo = sessionStorage?.getItem('redirect');

        let redirectParams: { [key:string]: string } = {};
        try {
          const redirectBody = JSON.parse(redirectInfo||'');
          redirectParams = redirectBody.queryParams;
        } catch (error: any){
          console.error('Failed to Parse redirect info', error.message);
        }
  
        if(boughtCoupon){
          switch(plan){
            case 'arrigo': 
              this.pageContentSelected.set(3);
            break;
            default: 
              this.pageContentSelected.set(2);
            break;
          }
        } else if(giftClaim){
          this.pageContentSelected.set(1);
        } else if(redirectParams.code?.toUpperCase().startsWith('CP')){
          //TODO: ask backend for colors of plan, etc?
          this.pageContentSelected.set(4);
        }        
      } catch (e){}

    });
  }

  phone: string|null = null;
  auth_id: string|null = null;
  timer: DateTime|null = null;

  onWaitingForVerification(response: IAuthRequest & IAuthResponse) {
    this.phone = `${response.country_code} ${response.phone}`;
    if(this.auth_id != response.auth_id && this.timer){
      this.timer = null;
    }
    this.auth_id = response.auth_id;
    this.state.set('verify');
    setTimeout(() => {
      this.verify()?.onWaitingForVerification(response, this.timer?.diff(DateTime.now()).as('seconds') ?? undefined);
    }, 10);
  }

  onVerifyStateChange(state: 'request' | 'register') {

    if(state == 'request'){
      this.timer = this.verify()?.timerTill ?? null;
    }

    this.state.set(state);
  }

  onVerified(event: IAuthVerified){
    this.loading.set(true);
    this.auth.login(event);
  }

  onRegistered(event: IAuthVerified){
    this.loading.set(true); 
    this.auth.login(event, 'register');
  }

  onRegisterStateChange(state: 'request'){
    
    //Hold register form?
    this.state.set(state);
  }

}
